import classNames from "classnames";
import React from "react";
import Tag from "../../atoms/tag/tag";
import "./eventCategoryTitle.sass";

export interface IEventCategoryTitleProps {
  title: string;
  total?: number;
  isExpanded: boolean;
}

const EventCategoryTitle: React.FC<IEventCategoryTitleProps> = ({
  title,
  total = 0,
  isExpanded
}) => {
  return (
    <div className="event-category-title">
      <div className={classNames({"is-expanded": isExpanded})}>{title}</div>
      <Tag
        text={total.toString()}
        type={isExpanded ? "system" : "neutral"}
      ></Tag>
    </div>
  );
};

export default EventCategoryTitle;
